<template>
  <div v-if="hasWarrantyInformation" class="warranty-information">
    <div class="warranty-title">Warranty Information</div>
    <div class="warranty-items">
      <div class="warranty-item" v-if="warrantyInformation.company">
        <div class="warranty-label">Company</div>
        <div class="warranty-value">{{ warrantyInformation.company }}</div>
      </div>
      <div class="warranty-item" v-if="warrantyInformation.project">
        <div class="warranty-label">Project</div>
        <div class="warranty-value">{{ warrantyInformation.project }}</div>
      </div>
      <div class="warranty-item" v-if="warrantyInformation.workOrderNumber && warrantyInformation.workOrderId">
        <div class="warranty-label">Work Order</div>
        <div class="warranty-value">
          <router-link :to="`/work-orders/${warrantyInformation.workOrderId}`">
            WO #{{ warrantyInformation.workOrderNumber }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarrantyInformation',
  props: {
    warrantyInformation: {
      type: Object,
      default: null,
    },
  },
  computed: {
    hasWarrantyInformation() {
      return (
        this.warrantyInformation &&
        (this.warrantyInformation.company ||
          this.warrantyInformation.project ||
          (this.warrantyInformation.workOrderId && this.warrantyInformation.workOrderNumber))
      );
    },
  },
};
</script>

<style scoped lang="scss">
.warranty-information {
  .warranty-title {
    margin-bottom: 0.5rem;
    font-weight: 600;
    font-size: 0.95rem;
  }

  .warranty-items {
    display: flex;
    flex-direction: column;

    .warranty-item {
      display: flex;
      flex-direction: row;
      margin: 0.25rem 0;
      align-items: center;

      .warranty-label {
        min-width: 150px;
        font-weight: 600;
        margin-right: 1rem;
        font-size: 0.9rem;
      }

      .warranty-value {
        flex-grow: 1;
        word-break: break-word;
        font-size: 0.9rem;

        a {
          color: #3273dc;
          text-decoration: underline;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>
